import { render, staticRenderFns } from "./CustomItem.vue?vue&type=template&id=a6766fd0&"
import script from "./CustomItem.vue?vue&type=script&lang=js&"
export * from "./CustomItem.vue?vue&type=script&lang=js&"
import style0 from "./CustomItem.vue?vue&type=style&index=0&id=a6766fd0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports